import React, { useEffect, useState, useRef } from 'react';
import AOS from 'aos';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import './css/main.css';
import './css/bootstrap.min.css';
import './css/style.css';

import Header from './components/header';
import logo2 from './icon_logo.png';
import Footer from './components/footer';

import Home from './pages/home';
import About from './pages/about';
import Contact from './pages/contact';
import Mission from './pages/our-mission';
import Careers from './pages/careers';
import Integrated_drilling_management from './pages/integrated_drilling_management';
import LightWims from './pages/lightWims';
import FdWms from './pages/fdWms';
import ManPower from './pages/man-power-supply';
import WellHead from './pages/wellheadServices';
import MudService from './pages/mudServices';
import Agencies from './pages/agencies';
import BPM from './pages/BPM';
import KCI from './pages/KCI';
import LanzhouLSPE from './pages/LanzhouLSPE';
import Reservoir from './pages/reservoir';
import Quote from './pages/quote';
import Inspection from './pages/inspection';
import HSE from './pages/hse';
import Norm from './pages/norm';
import Supply from './pages/supply';
import IntegratedDrillingManagement from './pages/integrated_drilling_management';
import AdminSettings from './components/AdminSettings';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import AdminBlog from './components/AdminBlog';
import ScrollToTop from './components/ScrollToTop';
import ProductionChemicals from './pages/productionChemicals';
import WasteTreating from './pages/wasteTreating';
import SeismicAcquisition from './pages/seismicAcquisition';
import News from './pages/news';
import Privacy from './pages/privacy';
import Terms from './pages/terms';
import TemporaryApplication from './pages/temporaryApplication';
import AI from './pages/ai';
import EventApply from './pages/EventApply';
import NptBreak from './pages/NptBreak';
import UniTrack from './pages/UniTrack';
import PPE from './pages/ppe';
import Events from './pages/Events';
import Albums from './pages/Albums';
import AlbumDetail from './pages/AlbumDetail';
import PetroTalent from './pages/PetroTalent';
import JMS from './pages/JMS';
import NNW from './pages/NNW';
import Bits from './pages/bits';
import DownholeTools from './pages/downholeTools';

function usePageTitle(baseTitle = 'Petrochoice') {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.toLowerCase();
    const titleMap = new Map([
      ['/', 'Home'],
      ['/about', 'About'],
      ['/mission-vision', 'Mission & Vision'],
      ['/contact', 'Contact'],
      ['/careers', 'Careers'],
      ['/integrated-drilling-management', 'Integrated Drilling Management'],
      ['/services/integrated-drilling', 'Integrated Drilling'],
      ['/services/integrated-drilling/light-wims', 'Light WIMS'],
      ['/services/integrated-drilling/fd-wms', 'FD WMS'],
      ['/services/manpower', 'Manpower Supply'],
      ['/services/wellhead', 'Wellhead Services'],
      ['/services/mud-services', 'Mud Services'],
      ['/services/bits', 'Drill Bits'],
      ['/services/downhole-tools', 'Downhole Tools'],
      ['/services/inspection', 'Inspection Services'],
      ['/services/hse-services', 'HSE Services'],
      ['/services/norm-services', 'NORM Services'],
      ['/services/reservoir-management', 'Reservoir Management'],
      ['/services/supply-chain', 'Supply Chain'],
      ['/services/ppe', 'PPE - Industrial Coveralls'],
      ['/services/software', 'AI Services'],
      ['/services/software/npt-break', 'NPT Break'],
      ['/services/software/uniface360', 'Uniface360'],
      ['/services/software/unitrack', 'UniTrack'],
      ['/services/software/jms', 'JMS - Journey Management System'],
      ['/services/petro-talent', 'PetroTalent'],
      ['/agencies', 'Agencies'],
      ['/agencies/production-chemicals', 'Evachem Technologies'],
      ['/agencies/waste-treating', 'Tasmania Limited'],
      ['/agencies/seismic-acquisition', 'Split Scientific Company'],
      ['/agencies/bpm', 'BPM'],
      ['/agencies/kci', 'KCI'],
      ['/agencies/lanzhou-lspe', 'Lanzhou LSPE'],
      ['/agencies/nnw', 'NNW Inc.'],
      ['/quote', 'Get a Quote'],
      ['/news', 'News'],
      ['/blog', 'Blog'],
      ['/admin', 'Admin'],
      ['/admin/blog', 'Admin Blog'],
      ['/privacy', 'Privacy Policy'],
      ['/terms', 'Terms & Conditions'],
      ['/temporary-application', 'Temporary Application'],
      ['/events', 'Company Events'],
      ['/albums', 'Photo Gallery'],
      ['/event-apply', 'Event Application'],
    ]);

    let pageTitle = titleMap.get(path);
    if (!pageTitle) {
      if (path.startsWith('/blog/')) pageTitle = 'Blog Post';
      else if (path.startsWith('/news/')) pageTitle = 'News Article';
    }
    const finalTitle = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;
    if (document && document.title !== finalTitle) {
      document.title = finalTitle;
    }
  }, [location.pathname, baseTitle]);
}

function TitleEffect() {
  usePageTitle('Petrochoice');
  return null;
}

function App() {
  const [isHeaderTransparent, setIsHeaderTransparent] = useState(true);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    // Set favicon to logo2
    const setFavicon = (href) => {
      const link = document.querySelector("link[rel='icon']");
      if (link) link.setAttribute('href', href);
      const apple = document.querySelector("link[rel='apple-touch-icon']");
      if (apple) apple.setAttribute('href', href);
    };
    setFavicon(logo2);
    // Scroll logic for header transparency
    const handleScroll = () => {
      if (window.scrollY < 80) {
        setIsHeaderTransparent(true);
      } else {
        setIsHeaderTransparent(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Standalone routes that don't show Header/Footer
  const standaloneRoutes = ['/services/petro-talent'];

  return (
    <Router>
      <ScrollToTop />
      <TitleEffect />
      <ConditionalLayout isHeaderTransparent={isHeaderTransparent} standaloneRoutes={standaloneRoutes}>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/blog" element={<AdminBlog />} />
          <Route path="/about" element={<About />} />
          <Route path="/mission-vision" element={<Mission />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/integrated-drilling-management" element={<Integrated_drilling_management />} />
          <Route path="/services/integrated-drilling" element={<IntegratedDrillingManagement />} />
          <Route path="/services/integrated-drilling/light-wims" element={<LightWims />} />
          <Route path="/services/integrated-drilling/fd-wms" element={<FdWms />} />
          <Route path="/services/manpower" element={<ManPower />} />
          <Route path="/services/wellhead" element={<WellHead />} />
          <Route path="/services/mud-services" element={<MudService />} />
          <Route path="/services/bits" element={<Bits />} />
          <Route path="/services/downhole-tools" element={<DownholeTools />} />
          <Route path="/services/inspection" element={<Inspection />} />
          <Route path="/services/hse-services" element={<HSE />} />
          <Route path="/services/norm-services" element={<Norm />} />
          <Route path="/services/reservoir-management" element={<Reservoir />} />
          <Route path="/services/supply-chain" element={<Supply />} />
          <Route path="/services/ppe" element={<PPE />} />
          <Route path="/services/software" element={<AI />} />
          <Route path="/services/software/npt-break" element={<NptBreak />} />
          <Route path="/services/software/uniface360" element={<AI />} />
          <Route path="/services/software/unitrack" element={<UniTrack />} />
          <Route path="/services/software/jms" element={<JMS />} />
          <Route path="/services/petro-talent" element={<PetroTalent />} />
          <Route path="/agencies/production-chemicals" element={<ProductionChemicals />} />
          <Route path="/agencies/waste-treating" element={<WasteTreating />} />
          <Route path="/agencies/seismic-acquisition" element={<SeismicAcquisition />} />
          <Route path="/agencies" element={<Agencies />} />
          <Route path="/agencies/bpm" element={<BPM />} />
          <Route path="/agencies/kci" element={<KCI />} />
          <Route path="/agencies/lanzhou-lspe" element={<LanzhouLSPE />} />
          <Route path="/agencies/nnw" element={<NNW />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/news" element={<News />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/news/:slug" element={<BlogPost />} />
          <Route path="/admin" element={<AdminSettings />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/temporary-application" element={<TemporaryApplication />} />
          <Route path="/events" element={<Events />} />
          <Route path="/albums" element={<Albums />} />
        <Route path="/albums/:id" element={<AlbumDetail />} />
          <Route path="/event-apply/:eventId/:formId" element={<EventApply />} />
        </Routes>

      </ConditionalLayout>
    </Router>
  );
}

// Layout wrapper that conditionally shows/hides Header and Footer
function ConditionalLayout({ children, isHeaderTransparent, standaloneRoutes }) {
  const location = useLocation();
  const isStandalone = standaloneRoutes.some(r => location.pathname === r);

  if (isStandalone) {
    return <>{children}</>;
  }

  return (
    <>
      <Header isTransparent={isHeaderTransparent} />
      {children}
      <Footer />
    </>
  );
}

export default App;
